import React from 'react';
import {Alert as AntAlert, AlertProps} from 'antd';

const Alert = (props: AlertProps) => {
	return <AntAlert {...props} />;
};

export default Alert;
